<p-panel>
  <app-reactive-form-builder
    [form]="form.formFields"
    [id]="getRegisterId()"
    [request]="request"
    [getRequest]="getRequest"
    [undoEnabled]="undoEnabled"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    (goBack)="goBack()">
  </app-reactive-form-builder>
</p-panel>
